import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';
import { saveAs } from 'file-saver/FileSaver';

import { APIBackUrl } from '../../../shared/api-back-url';
import { Location } from '../../../shared/models/location';
import { Company } from '../../../shared/models/company';
import { RequestForm } from '../../../shared/models/request-form';
import { NextAction } from '../../../shared/models/next-action';
import { Person } from "../../../shared/models/person";

@Injectable()
export class RequestFormService{
  constructor(
    private http: HttpClient
  ) { }

  listLocations(): Observable<Location[]>{
    return this.http
      .get<Location[]>( APIBackUrl.LIST_LOCATION, {observe: 'response'})
      .map(res => res.body as Location[]);
  }

  listCompanyByType(type: string): Observable<Company[]>{
    return this.http
      .get<Company[]>( `${APIBackUrl.LIST_COMPANY_BY_TYPE}/${type}`, {observe: 'response'})
      .map(res => res.body as Company[]);
  }

  saveRequestForm(formData: FormData){
    return this.http
      .post( `${APIBackUrl.SAVE_REQUEST_FORM}`, formData, {observe: 'response'})
      .map(res => res.body as RequestForm)
  }

  getRequestForm(requestFormId: number): Observable<RequestForm>{
    return this.http
      .get<RequestForm>( `${APIBackUrl.GET_REQUEST_FORM}/${requestFormId}`, {observe: 'response'})
      .map(res => res.body as RequestForm)
  }

  doAction(action: string, formData: FormData){
    return this.http
      .post( `${APIBackUrl.DO_ACTION_REQUEST_FORM}/${action}`, formData, {observe: 'response'})
      .map( res => res.body as RequestForm)
  }

  saveComment(formData: FormData){
    return this.http
      .post( `${APIBackUrl.SAVE_COMMENT}`, formData, {observe: 'response'})
      .map( res => res.body as RequestForm)
  }
  listPersonHistory(){
    return this.http
      .get<Person[]>(APIBackUrl.LIST_PERSON_HISTORY);
  }

  listPersonHistoryByCompany(companyId){
    return this.http
      .get<Person[]>(APIBackUrl.LIST_PERSON_HISTORY_BY_COMPANY + companyId);
  }

  downloadAttachment(attachmentId): Observable<HttpResponse<Blob>>{
    return this.http
      .get(`${APIBackUrl.DOWNLOAD_ATTACHMENT}/${attachmentId}`, { responseType: 'blob', observe: 'response' })
  }


}



// WEBPACK FOOTER //
// /app/src/app/modules/request/request-form/request-form.service.ts